"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/articleSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ArticleSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "5 Min to Read" | "10 Min to Read" | "15 Min to Read" */
    p0Text: ReactNode;
    /** Detected variants: "Elder Care" | "Rehabilitation" | "Home Care Tips" */
    span0Text: ReactNode;
    /** Detected variants: "How to Choose the Right Elder Caregiver for Your Parents" | "Expert rehabilitation services to help you recover faster" | "How to Create a Safe Home Environment for Patients" */
    link0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/about/article-img-1.jpg" | "/Templates/Doccure/img/about/article-img-2.jpg" | "/Templates/Doccure/img/about/article-img-3.jpg" */
    src: string;
    /** Detected variants: "col-lg-4 col-md-6" */
    className?: string;
    /** Detected variants: "article-item-nine wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "article-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "article-content" */
    div0ClassName3?: string;
    /** Detected variants: "article-info" */
    div0ClassName4?: string;
    /** Detected variants: "article-date" */
    p0ClassName?: string;
    /** Detected variants: "badge" */
    span0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "team" */
    alt?: string;
    /** Detected variants: "img-fluid img-one w-100" */
    imageWithBasePath0ClassName?: string;
};
export type HomeNineArticleSectionGeneratedProps = {
    divDiv0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ArticleSection46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0Div0H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ArticleSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "ARTICLES & TIPS" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Latest" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "from Doccure Homecare" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Articles" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "#" */
    sectionDiv0Div2Link0LinkHref?: string;
    /** Default: "View All Articles" */
    sectionDiv0Div2Link0LinkText?: ReactNode;
    sectionDiv0Div2Link0LinkVisible?: boolean;
    sectionDiv0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "testimonial" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/testimonial-icon.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/team-icon-1.svg" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    articleSection46s: ArticleSection46sItem[];
    articleSection46sItemWrapper?: (item: ArticleSection46sItem, content: ReactNode) => ReactNode;
    articleSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    articleSection46sLinkVisible?: boolean;
    articleSection46sLinkRenderer?: (item: ArticleSection46sItem, defaultNode: ReactNode) => ReactNode;
    articleSection46sImageVisible?: boolean;
    articleSection46sImageRenderer?: (item: ArticleSection46sItem, defaultNode: ReactNode) => ReactNode;
    articleSection46sH3Visible?: boolean;
    articleSection46sH3Renderer?: (item: ArticleSection46sItem, defaultNode: ReactNode) => ReactNode;
    articleSection46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ArticleSection46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    articleSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ArticleSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    articleSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: ArticleSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeNineArticleSectionGenerated: FC<HomeNineArticleSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "ARTICLES & TIPS",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Latest",
    sectionDiv0Div0H20H2Text2 = "from Doccure Homecare",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Articles",
    sectionDiv0Div2Link0LinkHref = "#",
    sectionDiv0Div2Link0LinkText = "View All Articles",
    sectionDiv0Div2Link0LinkVisible,
    sectionDiv0Div2Link0LinkRenderer,
    sectionDiv0Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "testimonial",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/testimonial-icon.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "icon",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/team-icon-1.svg",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div0H30H3Props,
    divDiv0Div0Div0H30Link0LinkProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1ClassName,
    articleSection46s,
    articleSection46sItemWrapper,
    articleSection46sRenderer,
    articleSection46sLinkVisible,
    articleSection46sLinkRenderer,
    articleSection46sImageVisible,
    articleSection46sImageRenderer,
    articleSection46sH3Visible,
    articleSection46sH3Renderer,
    articleSection46sLinkProps,
    articleSection46sImageProps,
    articleSection46sH3Props,
}) => {
    return (
        <section className="article-section-nine section">
            <div className="container">
                <div className="section-header section-header-nine text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="title">
                        <span className="dot" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary text-decoration-underline">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-3"}>
                    {renderCollectionNode(
                        articleSection46s,
                        (item: ArticleSection46sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "article-item-nine wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "article-overlay"}>
                                        {renderItemNode(articleSection46sImageVisible, articleSection46sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one w-100"} {...(typeof articleSection46sImageProps === "function" ? articleSection46sImageProps(item) : (articleSection46sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName3 ?? "article-content"}>
                                            <div className={item.div0ClassName4 ?? "article-info"}>
                                                <span className={item.span0ClassName ?? "badge"}>{item.span0Text}</span>
                                                <p className={item.p0ClassName ?? "article-date"}>{item.p0Text}</p>
                                            </div>
                                            {renderItemNode(articleSection46sH3Visible, articleSection46sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof articleSection46sH3Props === "function" ? articleSection46sH3Props(item) : (articleSection46sH3Props ?? {}))} {...(typeof divDiv0Div0Div0H30H3Props === "function" ? divDiv0Div0Div0H30H3Props(item) : (divDiv0Div0Div0H30H3Props ?? {}))}>
                                                    {renderItemNode(articleSection46sLinkVisible, articleSection46sLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} {...(typeof articleSection46sLinkProps === "function" ? articleSection46sLinkProps(item) : (articleSection46sLinkProps ?? {}))} {...(typeof divDiv0Div0Div0H30Link0LinkProps === "function" ? divDiv0Div0Div0H30Link0LinkProps(item) : (divDiv0Div0Div0H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ),
                        articleSection46sItemWrapper,
                        articleSection46sRenderer
                    )}
                </div>
                <div className="view-all text-center">
                    {renderNode(sectionDiv0Div2Link0LinkVisible, sectionDiv0Div2Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div2Link0LinkHref} className="btn btn-primary-gradient d-inline-flex align-items-center" {...(sectionDiv0Div2Link0LinkProps ?? {})}>
                            {" "}
                            <i className="isax isax-arrow-right-3 me-2" />
                            {sectionDiv0Div2Link0LinkText}
                        </SmartLink>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid element-one" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid icon-one" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeNineArticleSectionGenerated;
